import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/featureAccess/customer.featureAccess.userCodes.query.gql"
import type {
  CustomerFeatureAccessUserCodesQuery,
  CustomerFeatureAccessUserCodesQueryVariables,
} from "@/v2-backoffice-client/customer/featureAccess/__types__/customer.featureAccess.userCodes.query"

type Options = QueryHookOptions<
  CustomerFeatureAccessUserCodesQuery,
  CustomerFeatureAccessUserCodesQueryVariables
>

export function useCustomerFeatureAccessUserCodesQuery(options: Options) {
  return useQuery<
    CustomerFeatureAccessUserCodesQuery,
    CustomerFeatureAccessUserCodesQueryVariables
  >(query, options)
}
